import React from "react";
import { Box, FormControlLabel, Switch, Typography } from "@mui/material";
import RequestGuidePanel from "./RequestGuidePanel";

const RequestStatusRow = ({
  label,
  isLoading,
  isActive,
  isMissing = false,
  isDisabled = false,
  isUpdating = false,
  onToggle,
  showGuide = false,
  onClickGuide,
  showError = false,
  errorMessage,
  rowStyle,
  labelStyle,
  formControlLabelStyle,
}) => (
  <Box sx={rowStyle}>
    {isLoading || isMissing ? (
      <Typography sx={labelStyle(isMissing)}>{label}</Typography>
    ) : (
      <FormControlLabel
        sx={formControlLabelStyle}
        labelPlacement="start"
        label={<Typography sx={labelStyle(isMissing)}>{label}</Typography>}
        control={
          <Switch
            color="primary"
            checked={Boolean(isActive)}
            disabled={isDisabled || isMissing || isUpdating}
            onChange={(event) => onToggle(event.target.checked)}
          />
        }
      />
    )}

    {showGuide && <RequestGuidePanel onClick={onClickGuide} />}

    {showError && (
      <Typography color="error" sx={{ fontSize: "0.9rem" }}>
        {errorMessage}
      </Typography>
    )}
  </Box>
);

export default RequestStatusRow;
